<div *ngIf="actionText" class="formatted-text__body">
  <h2 *ngIf="actionText.title?.length">{{ actionText.title }}</h2>
  <div [internalInnerHtml]="actionText.body" [userEventSource]="userEventSource"></div>
  <div class="formatted-text__cta button__group">
    <a [airLink]="link" [userEventSource]="userEventSource" class="button button--border button--transparent">
      <span>{{ link.label }}</span>
      <i class="icon icon-{{ link.icon }}" *ngIf="link.icon"></i>
    </a>
  </div>
</div>
